import { render, staticRenderFns } from "./TeacherConv.vue?vue&type=template&id=12601e66&scoped=true"
import script from "./TeacherConv.vue?vue&type=script&lang=ts"
export * from "./TeacherConv.vue?vue&type=script&lang=ts"
import style0 from "./TeacherConv.vue?vue&type=style&index=0&id=12601e66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12601e66",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import TouchSwipe from 'quasar/src/directives/TouchSwipe.js';
import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QIcon,QBtn});qInstall(component, 'directives', {TouchSwipe,Ripple});
